import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { Tag, LessonMediaContent } from '../components'

const WordboxDetail = ({ lesson, intl }) => (
  <div className="width-full">
    <div className="width-full float-left">
      {
        lesson.tags.map(t => (
          <Tag tag={t} />
        ))
      }
    </div>
    <LessonMediaContent lesson={lesson} />
    <p className="wordbox-item">
      <span className="instructions">{lesson.instructions || intl.formatMessage(messages.fillWords)}</span>
      {
        lesson.wordbox.text.map((w, i) => (
          <span
            key={i}
            className={`float-left ${lesson.wordbox.fillIndexes.includes(i) ||
              lesson.wordbox.fillIndexes.some(range => range.from <= i && range.to > i) ? 'selected' : ''}`}
          >
            {`${w}`}
          </span>
        ))
      }
    </p>
  </div>
)

WordboxDetail.defaultProps = {
  lesson: null,
}

WordboxDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object,
}

const enhance = compose(injectIntl)

export default enhance(WordboxDetail)

const messages = defineMessages({
  fillWords: {
    id: 'wordboxDetail.fillWords',
    defaultMessage: 'Doplňte chýbajúce slová v texte.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/WordboxDetail.js